// @generated by protobuf-ts 2.9.0
// @generated from protobuf file "device_service.proto" (package "aeolus.proto", syntax proto3)
// tslint:disable
//
//
// Copyright (c) 2022 Cambridge Design Partnership.
// All rights reserved.
//
//
//*
// Defines the DeviceService service, and its request/response types
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { DeviceService } from "./device_service";
import type { SetRequestedDeviceConfigResponse } from "./device_service";
import type { SetRequestedDeviceConfigRequest } from "./device_service";
import type { GetRequestedDeviceConfigResponse } from "./device_service";
import type { GetRequestedDeviceConfigRequest } from "./device_service";
import type { SetDeviceMetadataResponse } from "./device_service";
import type { SetDeviceMetadataRequest } from "./device_service";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { GetDeviceDetailsResponse } from "./device_service";
import type { GetDeviceDetailsRequest } from "./device_service";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetDeviceIdsResponse } from "./device_service";
import type { GetDeviceIdsRequest } from "./device_service";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 *
 * Manages devices -- their list, updates on their state, etc
 *
 * This is intended to support pagination. The consumer first fetches the full list of devices with GetDeviceIds, which
 * is updated when devices are added/removed. Further data may be added to let the consumer properly sort the list in
 * future.
 *
 * Once the consumer has decided which device(s) it is interested in, it calls GetDeviceDetails passing these IDs, and is
 * given the status for each of these devices, updated whenever the status of a device changes.
 *
 * @generated from protobuf service aeolus.proto.DeviceService
 */
export interface IDeviceServiceClient {
    /**
     *
     * Fetch a list of all Device IDs of all devices.
     * This will return updated lists of devices as devices are added/removed
     *
     * @generated from protobuf rpc: GetDeviceIds(aeolus.proto.GetDeviceIdsRequest) returns (stream aeolus.proto.GetDeviceIdsResponse);
     */
    getDeviceIds(input: GetDeviceIdsRequest, options?: RpcOptions): ServerStreamingCall<GetDeviceIdsRequest, GetDeviceIdsResponse>;
    /**
     * *
     * Subscribe to state updates for a given set of devices
     *
     * @generated from protobuf rpc: GetDeviceDetails(aeolus.proto.GetDeviceDetailsRequest) returns (stream aeolus.proto.GetDeviceDetailsResponse);
     */
    getDeviceDetails(input: GetDeviceDetailsRequest, options?: RpcOptions): ServerStreamingCall<GetDeviceDetailsRequest, GetDeviceDetailsResponse>;
    /**
     * *
     * Update the metadata for a particular device
     *
     * Partial updates are supported: the request may omit any of the fields of the DeviceMetadataMessage portion of the
     * request, and these will be ignored.
     *
     * Returns:
     *  - NOT_FOUND: The specified device_id doesn't exist
     *
     * @generated from protobuf rpc: SetDeviceMetadata(aeolus.proto.SetDeviceMetadataRequest) returns (aeolus.proto.SetDeviceMetadataResponse);
     */
    setDeviceMetadata(input: SetDeviceMetadataRequest, options?: RpcOptions): UnaryCall<SetDeviceMetadataRequest, SetDeviceMetadataResponse>;
    /**
     * @generated from protobuf rpc: GetRequestedDeviceConfig(aeolus.proto.GetRequestedDeviceConfigRequest) returns (stream aeolus.proto.GetRequestedDeviceConfigResponse);
     */
    getRequestedDeviceConfig(input: GetRequestedDeviceConfigRequest, options?: RpcOptions): ServerStreamingCall<GetRequestedDeviceConfigRequest, GetRequestedDeviceConfigResponse>;
    /**
     * @generated from protobuf rpc: SetRequestedDeviceConfig(aeolus.proto.SetRequestedDeviceConfigRequest) returns (aeolus.proto.SetRequestedDeviceConfigResponse);
     */
    setRequestedDeviceConfig(input: SetRequestedDeviceConfigRequest, options?: RpcOptions): UnaryCall<SetRequestedDeviceConfigRequest, SetRequestedDeviceConfigResponse>;
}
/**
 *
 * Manages devices -- their list, updates on their state, etc
 *
 * This is intended to support pagination. The consumer first fetches the full list of devices with GetDeviceIds, which
 * is updated when devices are added/removed. Further data may be added to let the consumer properly sort the list in
 * future.
 *
 * Once the consumer has decided which device(s) it is interested in, it calls GetDeviceDetails passing these IDs, and is
 * given the status for each of these devices, updated whenever the status of a device changes.
 *
 * @generated from protobuf service aeolus.proto.DeviceService
 */
export class DeviceServiceClient implements IDeviceServiceClient, ServiceInfo {
    typeName = DeviceService.typeName;
    methods = DeviceService.methods;
    options = DeviceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     *
     * Fetch a list of all Device IDs of all devices.
     * This will return updated lists of devices as devices are added/removed
     *
     * @generated from protobuf rpc: GetDeviceIds(aeolus.proto.GetDeviceIdsRequest) returns (stream aeolus.proto.GetDeviceIdsResponse);
     */
    getDeviceIds(input: GetDeviceIdsRequest, options?: RpcOptions): ServerStreamingCall<GetDeviceIdsRequest, GetDeviceIdsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDeviceIdsRequest, GetDeviceIdsResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * *
     * Subscribe to state updates for a given set of devices
     *
     * @generated from protobuf rpc: GetDeviceDetails(aeolus.proto.GetDeviceDetailsRequest) returns (stream aeolus.proto.GetDeviceDetailsResponse);
     */
    getDeviceDetails(input: GetDeviceDetailsRequest, options?: RpcOptions): ServerStreamingCall<GetDeviceDetailsRequest, GetDeviceDetailsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDeviceDetailsRequest, GetDeviceDetailsResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * *
     * Update the metadata for a particular device
     *
     * Partial updates are supported: the request may omit any of the fields of the DeviceMetadataMessage portion of the
     * request, and these will be ignored.
     *
     * Returns:
     *  - NOT_FOUND: The specified device_id doesn't exist
     *
     * @generated from protobuf rpc: SetDeviceMetadata(aeolus.proto.SetDeviceMetadataRequest) returns (aeolus.proto.SetDeviceMetadataResponse);
     */
    setDeviceMetadata(input: SetDeviceMetadataRequest, options?: RpcOptions): UnaryCall<SetDeviceMetadataRequest, SetDeviceMetadataResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetDeviceMetadataRequest, SetDeviceMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRequestedDeviceConfig(aeolus.proto.GetRequestedDeviceConfigRequest) returns (stream aeolus.proto.GetRequestedDeviceConfigResponse);
     */
    getRequestedDeviceConfig(input: GetRequestedDeviceConfigRequest, options?: RpcOptions): ServerStreamingCall<GetRequestedDeviceConfigRequest, GetRequestedDeviceConfigResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRequestedDeviceConfigRequest, GetRequestedDeviceConfigResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetRequestedDeviceConfig(aeolus.proto.SetRequestedDeviceConfigRequest) returns (aeolus.proto.SetRequestedDeviceConfigResponse);
     */
    setRequestedDeviceConfig(input: SetRequestedDeviceConfigRequest, options?: RpcOptions): UnaryCall<SetRequestedDeviceConfigRequest, SetRequestedDeviceConfigResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetRequestedDeviceConfigRequest, SetRequestedDeviceConfigResponse>("unary", this._transport, method, opt, input);
    }
}
